/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TuteurSelectorGridDto
 */
export interface TuteurSelectorGridDto {
    /**
     * 
     * @type {number}
     * @memberof TuteurSelectorGridDto
     */
    idtuteur?: number;
    /**
     * 
     * @type {number}
     * @memberof TuteurSelectorGridDto
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {string}
     * @memberof TuteurSelectorGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurSelectorGridDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurSelectorGridDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurSelectorGridDto
     */
    gsm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurSelectorGridDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurSelectorGridDto
     */
    localite?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurSelectorGridDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurSelectorGridDto
     */
    localiteNaissance?: string | null;
}

/**
 * Check if a given object implements the TuteurSelectorGridDto interface.
 */
export function instanceOfTuteurSelectorGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurSelectorGridDtoFromJSON(json: any): TuteurSelectorGridDto {
    return TuteurSelectorGridDtoFromJSONTyped(json, false);
}

export function TuteurSelectorGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurSelectorGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'gsm': !exists(json, 'gsm') ? undefined : json['gsm'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'localiteNaissance': !exists(json, 'localiteNaissance') ? undefined : json['localiteNaissance'],
    };
}

export function TuteurSelectorGridDtoToJSON(value?: TuteurSelectorGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtuteur': value.idtuteur,
        'idlieuFormation': value.idlieuFormation,
        'nom': value.nom,
        'prenom': value.prenom,
        'telephone': value.telephone,
        'gsm': value.gsm,
        'email': value.email,
        'localite': value.localite,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'localiteNaissance': value.localiteNaissance,
    };
}

